import { css, styled } from '@mui/material'

import bg from './girl-sad.png'

import { url } from '~/core/styles'

export const GirlSad = styled('div')<{ $width: string }>(
  ({ $width }) => css`
    width: ${$width};
    height: calc(${$width} / 552 * 330);
    background-image: ${url(bg)};
  `
)
